/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * Created by PanJiaChen on 16/11/18.
 */
// 品质的颜色
// 颜色:#e4ae39  名称:违禁  标识:rarity_contraband
//  颜色:#EB4B4B  名称:隐秘  标识:rarity_ancient_weapon
//  颜色:#d32ce6  名称:保密  标识:rarity_legendary_weapon
//  颜色:#8847ff  名称:受限  标识:rarity_mythical_weapon
//  颜色:#4B69FF  名称:军规级  标识:rarity_rare_weapon
//  颜色:#5e98d9  名称:工业级  标识:rarity_uncommon_weapon
//  颜色:#b0c3d9  名称:消费级  标识:rarity_common_weapon
//  颜色:#eb4b4b  名称:非凡  标识:rarity_ancient
//  颜色:#8847ff  名称:卓越  标识:rarity_mythical
//  颜色:#d32ce6  名称:奇异  标识:rarity_legendary
//  颜色:#4b69ff  名称:高级  标识:rarity_rare
//  颜色:#b0c3d9  名称:普通级  标识:rarity_common
//  颜色:#4B69FF  名称:探员高级  标识:rarity_rare_character
//  颜色:#8847FF  名称:探员卓越  标识:rarity_mythical_character
//  颜色:#D32CE6  名称:探员非凡  标识:rarity_legendary_character
//  颜色:#EB4B4B  名称:探员大师  标识:rarity_ancient_character
// 主要 7中颜色

let colorObj = {
  darkBlue: {
    key: 'darkBlue-skin',
    color: '#4B69FF',
    colorArr: ['#4B69FF','#4169E1'],
    signArr: ['rarity_rare_weapon','rarity_rare','rarity_rare_character'],
    name:'深蓝色'  
  },
  babyBlue: {
    key: 'babyBlue-skin',
    color: '#5e98d9',
    colorArr: ['#5e98d9'],
    signArr: ['rarity_uncommon_weapon'],
    name:'深蓝色'  
  },
  yellow: {
    key: 'yellow-skin',
    color: '#e4ae39',
    colorArr: ['#e4ae39','#FFA500'],
    signArr: ['rarity_contraband'],
    name:'黄色'  
  },
  red: {
    key: 'red-skin',
    color: '#EB4B4B',
    colorArr: ['#FF4500'],
    signArr: ['rarity_ancient_weapon','rarity_ancient','rarity_ancient_character'],
    name:'红色'  
  },
  lavender: {
    key: 'lavender-skin',
    color: '#d32ce6',
    colorArr: ['#d32ce6'],
    signArr: ['rarity_legendary_weapon','rarity_legendary','rarity_legendary_character'],
    name:'粉紫色'  
  },
  eggplant: {
    key: 'eggplant-skin',
    color: '#8847ff',
    colorArr: ['#8847ff'],
    signArr: ['rarity_mythical_weapon','rarity_mythical_character','rarity_mythical'],
    name:'茄子色'  
  },
  gray: {
    key: 'gray-skin',
    color: '#b0c3d9',
    colorArr: ['#b0c3d9'],
    signArr: ['rarity_common','rarity_common_weapon','rarity_common_weapon'],
    name:'灰色'  
  },
}
/**
 * Parse the time to string
 * @param {(string)} skinObj:对象饰品 
 * @returns {string | null} value 对比的值是什么可以有 rarity 品质 price 价格
 * 
 */
// 这边可以根据品质字段判断，可以根据价格进行判断
export function parseColor(skinObj,value, key,boxPrice) {
  if (!value) {
    value = 'price'
  }
  if (!key) {
    key = 'key'
  }
  // 品质标识
  if (value==='rarity') {
    for (const i in colorObj) {
      if (colorObj[i].signArr.indexOf(skinObj.rarity)!=-1) {
        return colorObj[i][key]
      }
    }
    // 价格对比
  } else if (value==='price') {
    if(50<skinObj.price*1&& skinObj.price*1 <200){
      return key == 'key'?'red-skin':'#EB4B4B'
    }
    if(skinObj.price*1>=200){
      return key == 'key'?'yellow-skin':'#e4ae39'
    }
    return key == 'key' ? 'babyBlue-skin' : '#5e98d9'
    // 颜色
  } else if (value==='color') {
    for (const i in colorObj) {
      if (colorObj[i].colorArr.indexOf(skinObj.color)!=-1) {
        return colorObj[i][key]
      }
    }
    return colorObj.darkBlue[key]
    // 这个是跟箱子经常对比
  } else if (value==='price_box') {
    if(skinObj.price*1>boxPrice){
      return key == 'key'?'red-skin':'#EB4B4B'
    }
    return key == 'key' ? 'babyBlue-skin' : '#5e98d9'
  }  
  return ''
}
